<template>
  <ion-modal :is-open="showLinkInput" @didDismiss="$emit('close')" :initial-breakpoint="1" :breakpoints="[0, 0.5, 1]"
    class="custom-modal">
    <div class="modal-content">
      <div class="header-section">
        <h3>Bagikan Link</h3>
        <p>Gunakan link di bawah ini untuk mengakses produk</p>
      </div>

      <div class="input-wrapper">
        <ion-input mode="md" fill="outline" readonly :value="url" class="modern-input"></ion-input>

        <ion-button @click="copyUrl" class="copy-btn" mode="ios">
          <ion-icon slot="start" :icon="copyOutline"></ion-icon>
          Salin
        </ion-button>
      </div>
    </div>
  </ion-modal>
</template>

<script>
import {
  IonButton,
  IonInput,
  IonModal,
  IonIcon,
  toastController
} from '@ionic/vue';
import { copyOutline } from 'ionicons/icons';

export default {
  name: "InputUrlCopy",
  props: {
    url: String,
    showLinkInput: Boolean
  },
  components: { IonButton, IonInput, IonModal, IonIcon },
  setup() {
    return { copyOutline };
  },
  methods: {
    async copyUrl() {
      try {
        // Menggunakan Clipboard API modern
        await navigator.clipboard.writeText(this.url);

        const toast = await toastController.create({
          message: "Link berhasil disalin ke clipboard",
          duration: 2000,
          position: 'bottom',
          color: 'dark',
          mode: 'ios'
        });
        await toast.present();
      } catch (err) {
        console.error('Gagal menyalin: ', err);
      }
    }
  },
};
</script>

<style scoped>
/* Modal Styling */
.custom-modal {
  --height: auto;
  --border-radius: 24px 24px 0 0;
}

.modal-content {
  padding: 24px;
  background: #ffffff;
}

.header-section {
  margin-bottom: 20px;
}

.header-section h3 {
  margin: 0;
  font-weight: 700;
  color: #2c3e50;
  font-size: 1.2rem;
}

.header-section p {
  margin: 4px 0 0 0;
  color: #7f8c8d;
  font-size: 0.85rem;
}

/* Input & Button Container */
.input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f9fa;
  padding: 8px;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.modern-input {
  --padding-start: 12px;
  --background: transparent;
  --color: #2c3e50;
  font-size: 0.9rem;
  font-weight: 500;
}

.copy-btn {
  --background: var(--primary-color, #8C1115);
  --border-radius: 8px;
  --box-shadow: none;
  font-weight: 600;
  height: 40px;
  margin: 0;
}

/* Menghilangkan border focus default ionic */
ion-input.modern-input {
  --border-style: none;
  --highlight-color-focused: transparent;
}
</style>